/* eslint-disable @typescript-eslint/no-explicit-any */
import { searchByName } from '@/shared/lib'
import { useEffect, useState } from 'react'

import { useDebounce } from './useDebounceHook'

import { debounceSpeedMedium } from '@/shared/constants/appConstants'
import { ChannelType } from '@/shared/types/appTypes'

const useSearchBy = (arrayToFilter: ChannelType[], searchValue: string) => {
    const [filteredArray, setFilteredArray] = useState(arrayToFilter)
    const debouncedValue = useDebounce(searchValue, debounceSpeedMedium)

    useEffect(() => {
        if (searchValue.length) {
            const filteredArray = searchByName(debouncedValue, arrayToFilter)

            if (filteredArray) setFilteredArray(filteredArray)
        } else setFilteredArray(arrayToFilter)
    }, [debouncedValue])

    return { filteredArray }
}

export { useSearchBy }
